import PropTypes from 'prop-types'
import BlueSectionItem from './BlueSectionItem'

const BlueSection = ({ title, items }) => {
  return (
    <div id="blue-section" className="gap-x-primary grid grid-cols-12">
      <h3
        id="contactBlueSectionTitle"
        className="col-span-full m-0 px-10 text-center text-4xl font-bold leading-extra-loose text-white lg:col-span-6 lg:col-start-4 lg:px-0 xl:mx-12"
      >
        {title}
      </h3>
      <div className="col-span-full mt-8 flex flex-col justify-center lg:mt-16 lg:flex-row">
        {items.map((item) => {
          return (
            <BlueSectionItem
              key={item.id}
              itemTitle={item.itemTitle}
              itemText={item.itemText}
            />
          )
        })}
      </div>
    </div>
  )
}

BlueSection.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      itemTitle: PropTypes.string.isRequired,
      itemText: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default BlueSection
